(() => {
	let buildBreakpoints = (max, mobile) => {
		const steps = [
			{ width: 0, value: mobile },
			{ width: 576, value: 2 },
			{ width: 750, value: 3 },
			{ width: 1200, value: 4 },
			{ width: 1360, value: 5 },
			{ width: 1600, value: 6 }
		];

		const breakpoints = {};

		steps.forEach((step) => {
			breakpoints[step.width] = {
				slidesPerView: Math.min(step.value, max)
			};
		});

		return breakpoints;
	};

	let initProductCarouselSliders = () => {
		$(".product-carousel-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return;
			}

			$(this).addClass("slider_started");

			let id = $(this).attr("id");
			let slideEl = $(this).find(".swiper-wrapper");
			let productCount = parseInt(slideEl.data("count"));
			let productCountMobile = parseInt(slideEl.data("count-mobile"));

			// Cards are the slides, and section-product-carousel.css makes the wrapper a flex row with
			// height:auto slides, so they already stretch to the tallest card. The old JS equaliser
			// re-measured every card on each Swiper event (forced layouts on a ~11k-node page).
			let prodSwiperParams = {
				loop: false,
				autoHeight: false,
				allowTouchMove: true,
				slidesPerView: Math.min(productCountMobile, productCount),
				lazy: true,
				preloadImages: false,
				spaceBetween: 24,
				observer: true,
				observeParents: true,
				breakpoints: buildBreakpoints(productCount, productCountMobile),
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`
				}
			};

			new Swiper(`#${id} .product-carousel-swiper`, prodSwiperParams);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductCarouselSliders();
	});

	initProductCarouselSliders();
})();